export const SELECTOR_IS_AUTH = (state) => state.auth.isAuthenticate;
export const SELECTOR_USER = (state) => state.auth.user;

export const SELECTOR_USER_PENDING_SECURITY = (state) =>
  state.auth.hasPendingSecurity;
export const SELECTOR_USER_PENDING_DATA = (state) =>
  state.auth.hasPendingUserData;
export const SELECTOR_USER_PENDING = (state) =>
  SELECTOR_USER_PENDING_DATA(state) || SELECTOR_USER_PENDING_SECURITY(state);
